import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';

import validateMoulages from './validateMoulages';
import validatePosition from './validatePosition';
import validateWeightHeight from './validateWeighHeight';

function validatePatientConditions(caseConf) {
  const validationResults = [
    validateMoulages(caseConf),
    validatePosition(caseConf),
    validateWeightHeight(caseConf),
  ];
  return mergeWith({}, ...validationResults, (objValue, srcValue) => {
    if (isArray(objValue)) {
      return objValue.concat(srcValue);
    }
    return undefined;
  });
}

export default validatePatientConditions;
